import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { NoteModule } from "@e-forsyning/common/note";

import { ServicerapportAccordionPanelModule } from "../shared/servicerapport-accordion-panel/servicerapport-accordion-panel.module";
import { OpgaveNoteListeComponent } from "./opgave-note-liste/opgave-note-liste.component";

@NgModule({
    imports: [CommonModule, NoteModule, ReactiveFormsModule, ServicerapportAccordionPanelModule],
    exports: [OpgaveNoteListeComponent],
    declarations: [OpgaveNoteListeComponent],
    providers: []
})
export class OpgaveNoteModule {}
